/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Component, OnInit, ViewChild } from '@angular/core';

import { Country, DataService } from './data.service';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IqSelect2Item, IqSelect2Component } from 'ng2-iq-select2';


@Component({
    selector: 'nb-card-test',
    templateUrl: './card-test.component.html',
})
export class NbCardTestComponent implements OnInit {

    public form: FormGroup;
    public listItems: (term: string) => Observable<Country[]>;
    public listItemsMax: (term: string) => Observable<Country[]>;
    public getItems: (ids: string[]) => Observable<Country[]>;
    public entityToIqSelect2Item: (entity: Country) => IqSelect2Item;
    public count: number;
    @ViewChild('countrySingle') countrySingle: IqSelect2Component<Country>;

    sizes = ['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge'];
    // statuses = ['primary', 'purple', 'blue', 'green', 'danger', 'active', 'disabled',
    //              'primary', 'purple', 'blue', 'green', 'danger', 'active', 'disabled',
    //              'primary', 'purple', 'blue', 'green', 'danger', 'active', 'disabled'];
    statuses = ['primary', 'purple', 'blue', 'disabled'];

    cards: any[];

    constructor(private dataService: DataService,
        private formBuilder: FormBuilder) {
        this.cards = this.prepareCards();
    }

    private prepareCards(): any[] {
        const result = [];

        this.statuses.forEach(status => {
            this.sizes.forEach(size => {
                result.push({
                    size,
                    status,
                });
            });
        });

        return result;
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            firstname: {
                value: '',
                disabled: true,
            },
            lastname: new FormControl(''),
            option: new FormControl(''),
            countrySingle: [{
                id: '16',
                name: 'Argentina',
                code: 'AR',
                color: '#c1ee5b',
            }, Validators.required],
            countryMultiple: null,
            countryMultipleDisabled: new FormControl({
                value: [{
                    id: '16',
                    name: 'Argentina',
                    code: 'AR',
                    color: '#c1ee5b',
                }, {
                    id: '17',
                    name: 'Indonesia',
                    code: 'ID',
                    color: '#19f77a',
                }],
                disabled: true,
            }),
            countrySingleMin0: null,
            countryMultipleMin0: [[{
                id: '16',
                name: 'Argentina',
                code: 'AR',
                color: '#c1ee5b',
            }]],
            countryMin0Count: null,
            habilitado: true,
        });
        this.initializeCountryIqSelect2();
        this.form.valueChanges.subscribe(() => {
            // console.log('-->' + this.form.controls['countrySingle'].value);
        });
    }

    private initializeCountryIqSelect2() {
        this.listItems = (term: string) => this.dataService.listData(term);
        this.listItemsMax = (term: string) =>
            this.dataService.listDataMax(term, 3).map((response) => {
                this.count = response.count;
                return response.results;
            });
        this.getItems = (ids: string[]) => this.dataService.getItems(ids);
        this.entityToIqSelect2Item = (entity: any) => {
            return {
                id: entity.id,
                text: entity.name,
                entity: entity,
            };
        };
    }

    send(formJson: string) {
        // console.log(formJson);
    }

    onSelect(item: IqSelect2Item) {
        // console.log('Item selected: ' + item.text);
    }

    onRemove(item: IqSelect2Item) {
        // console.log('Item removed: ' + item.text);
    }

    reset() {
        // console.log('Resetting form');
        this.form.reset();
    }
}



// WEBPACK FOOTER //
// ./src/app/card-test/card-test.component.ts